<template>
  <div class="pricing-data" :class="{ 'pricing-data--not-last': isNotLast,'pricing-data--hidden': ishidden }">
    <i class="pricing-data__icon"></i>
    <p v-html="pricingDataText" class='pricing-data__text'></p>
  </div>
</template>

<script lang="ts">
import {
  Component,
  Prop,
  Provide,
  Vue,
  Watch
} from 'vue-property-decorator';

@Component
export default class PricingDataComponent extends Vue {
  @Prop({ default: 'Pricing Data given with every enquiry' })
  public pricingDataText!: string;

  @Prop({ default: true })
  public isNotLast!: boolean;

  @Prop({ default: false })
  public ishidden!: boolean;
}
</script>
